
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const PredictorCrash = lazy(() => import('../pages/predictor-crash/page'));
const PredictorAviator = lazy(() => import('../pages/predictor-aviator/page'));
const Signup = lazy(() => import('../pages/signup/page'));
const Login = lazy(() => import('../pages/login/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const WatchAds = lazy(() => import('../pages/watch-ads/page'));
const Payment = lazy(() => import('../pages/payment/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/predictor-crash',
    element: <PredictorCrash />,
  },
  {
    path: '/predictor-aviator',
    element: <PredictorAviator />,
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/watch-ads',
    element: <WatchAds />,
  },
  {
    path: '/payment',
    element: <Payment />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
